export const MassValidationKeys = {
  Name: 'name',
  Ring: 'ring',
  Start: 'start',
  End: 'end',
  Ended: 'ended',
};

export const COLUMN_WIDTH = 100;
export const TABLE_WIDTH = 600;
export const DRAWER_WIDTH = TABLE_WIDTH + 100;
